import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function ResetFilters() {
  const { onResetFilter, setSelectedRows, resetContentSearch } = useFileManagerContext();

  // Use sync icon consistently across all file manager instances
  return (
    <div className="pointer ms-0 p-2">
      <i
        className="fas fa-sync-alt"
        onClick={() => {
          resetContentSearch();
          onResetFilter();
          setSelectedRows([]);
        }}
      ></i>
      <Tooltip content="Reset Filter" position="top" target=".fa-sync-alt" showDelay={500} />
    </div>
  );
}

export default ResetFilters;
